import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Group, KeypadOption, NoInfo, UserList } from '../styles/dialpadstyle';
import { RecentList } from './dialpad'
import { connect } from 'react-redux';
import SpinnerIcon from '../../../../common/components/SpinnerIcon'
import { globalStateSelector } from '../../../../../store/selector';
import {
  globalAction,
} from '../../../../../store/action';

import {
  FormWrapper,
  FormColumn,
  FormGroup,
  ControlLabel,
  Spinner,
  FormControl,
  Button
} from 'modules/theme';
import styled from 'styled-components';
global.__callBtn = "";

const CustomKeypadOption = styled.div`
	display: flex;
	align-items: center;
	margin: 10px;
	input {
		margin: 0px;
		height: 38px;
		border-radius: 19px;
	}
`

const CallBackResponsive = styled.div`
{
  height: 360px;
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (max-width: 768px) {
    height: 100%;
    width: 100%;
  } 
}`

export class CallbackScreenTheme extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading : false,
      phoneNumber: "",
    }
    this.startTimer = this.startTimer.bind(this);
    this.getList = this.getList.bind(this);
  }
  renderFormGroup(label, props) {
    return (
      <FormGroup className="m-0 flex-grow-1">
        {/* <ControlLabel required={props.required}>{label}</ControlLabel> */}
        <FormControl {...props} />
      </FormGroup>
    );
  }

  startTimer() {
    const { dynamicUpdate } = this.props
    clearTimeout(global.__callBtn);
    if( this.state.phoneNumber && this.state.phoneNumber.length > 3 ) {
      this.setState({"loading":true})
      dynamicUpdate({ key: 'callHandlingLoader', value: true });
      global.__callBtn  = setTimeout(()=>{
        dynamicUpdate({ key: 'callHandlingLoader', value: false });
      },10000)
    }
  }
  getList() {
    const { callList, callProcess, cbListLoading } = this.props

    if(  cbListLoading ){
      return (
        <NoInfo>
          <img style={{"marginBottom": "10px"}} src="images/icons/overtime.png" />
          <span>Please wait we are preparing the list</span>
          <h4>Loading...</h4>
        </NoInfo>
      )
    }
    if( callList && callList.length ){
      return (
        <React.Fragment>
          {callList.map(data => {
            return (
              <RecentList
                image={this.getTypeUrl(data.type)}
                name={data.name}
                message={data.message}
                // extraMessage={data.extraMessage || ""}
                time={data.time}
                dialNumber={callProcess}
                callInfo={data}
              />
            );
          })}
        </React.Fragment>
      )
    } else {
      return (
        <NoInfo>
          <img style={{"marginBottom": "10px"}} src="images/icons/overtime.png" />
          <span>You have no upcoming callback</span>
          <h4>No CallBack</h4>
        </NoInfo>
      )
    }
  }
  getTypeUrl(type) {
    return 'images/icons/call-male.png';
  }
  render() {

    const {
      cbListLoading,
      btnCall,
      onNumberKeyPress,
      onNumberChange,
      onCall,
      teamName,
      teamList,
      callTeam
    } = this.props;
    return (
      <CallBackResponsive>
        <div>
          <CustomKeypadOption>
                {this.renderFormGroup('', {
                  type: 'tel',
                  defaultValue: '',
                  placeholder: `Find CallBack Number`,
                  autoFocus: false,
                  required: true,
                  id: 'number',
                  value: this.props.number,
                  onKeyPress: onNumberKeyPress,
                  // onKeyPress:teamName ? (event)=>{
                  //   onNumberKeyPress(event);
                  //   if (event.key === 'Enter') {
                  //     this.startTimer();
                  //   }
                  // }:()=>{ // restricted data
                  // },
                  // onChange: onNumberChanges,
                  onChange: (event)=>{
                    // if ( event.target.value ) {
                    //   this.setState({phoneNumber : event.target.value})
                    // } else {
                    //   this.setState({phoneNumber : ""})
                    // }
                    onNumberChange(event)
                  }
                })}
            <Button
				style={{padding: 0, margin: 5}}
              btnStyle="link"
              type="simple"
              disabled = {teamName ? false : true}
            >

              { !cbListLoading &&
                <img
                  src={btnCall}
                  style={{ width: '38px' }}
                  onClick={()=>{
                    this.startTimer();
                    onCall();
                  }}/>
              }
              { cbListLoading && <SpinnerIcon style={{
                  width: "38px",
                  marginTop: "0px",
                  paddingTop: "6px",
                  justifyContent: "center",
                  height: "38px",
                  background: "#eee7f9",
                  borderRadius: "20px",
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                }}/>
              }
            </Button>
          </CustomKeypadOption>
        </div>
        <UserList>
          {this.getList()}
        </UserList>
      </CallBackResponsive>
    )
  }
}

CallbackScreenTheme.contextTypes = {
  __: PropTypes.func
};

const stateToProps = state => ({
  teamList: globalStateSelector.getTeamList(state),
  team: globalStateSelector.getSelectedTeam(state),
  teamName: globalStateSelector.getDynamic(state, { key: 'dialPadTeamName' }),
  cbListLoading: globalStateSelector.getDynamic(state, { key: 'cbListLoading' }),
  callTeam: globalStateSelector.getDynamic(state, { key: 'callTeam' }),
  teamList: globalStateSelector.getTeamList(state),
});

const dispatchToProps = dispatch => ({
  dynamicUpdate: data => {
    dispatch(globalAction.dynamicUpdate({ data }));
  },
});
export default connect(stateToProps, dispatchToProps)(CallbackScreenTheme);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/CallbackScreenTheme.js